import React from 'react';
import { FadeIn } from './FadeIn';
export function PainPoints() {
  return <section className="py-16 px-6 max-w-3xl mx-auto" data-id="element-156">
      <FadeIn data-id="element-157">
        <div className="space-y-8 text-xl md:text-2xl text-brown leading-relaxed font-serif" data-id="element-158">
          <p className="text-center italic font-medium text-brown-dark" data-id="element-159">
            ¿Le duelen las rodillas al levantarse cada mañana?
          </p>
          <p className="text-center italic font-medium text-brown-dark" data-id="element-160">
            ¿Siente que su cuerpo ya no descansa aunque duerma toda la noche?
          </p>

          <div className="mt-12 space-y-6 text-lg md:text-xl font-sans" data-id="element-161">
            <p data-id="element-162">
              Usted no está envejeciendo mal. Su cuerpo simplemente está
              pidiendo lo que siempre supo que funcionaba.
            </p>
            <p data-id="element-163">
              Esos remedios que su mamá y su abuela usaban en la cocina... esa
              sabiduría que cruzó fronteras con usted... todavía existe. Solo
              hay que saber dónde encontrarla aquí, en este país.
            </p>
            <p className="font-medium bg-amber/10 p-6 rounded-2xl border border-amber/20" data-id="element-164">
              El problema no es la edad. El problema es que nadie le ha dicho
              que en su Walmart más cercano están exactamente los mismos
              ingredientes que su abuela usaba para aliviar el dolor, dormir
              profundo y despertar con energía.
            </p>
          </div>
        </div>
      </FadeIn>
    </section>;
}